/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Plugins.MeevoMessenger {
    export class MeevoMessengerAutoFocus implements angular.IDirective {
        restrict = 'A';
        link = (scope: any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes) => {
            var setFocus = () => {
                this.$timeout(() => element[0].focus());
            };

            if (attrs['ngDisabled']) {
                scope.$watch(() => attrs['disabled'], () => {
                    if (!attrs['disabled']) setFocus();
                });
            }
        };

        constructor(
            protected $timeout: ng.ITimeoutService
        ) { }

        static factory(): angular.IDirectiveFactory {
            let directive = ($timeout) => new MeevoMessengerAutoFocus($timeout);
            directive.$inject = [
                '$timeout'
            ];

            return directive;
        }
    }

    angular.module('meevo.plugins.meevoMessenger')
        .directive('meevoMessengerAutoFocus', MeevoMessengerAutoFocus.factory());
}
